import React, {Component} from 'react';
import {
  Link
} from 'react-router-dom';

import './clientBusinessNav.css';

/**
 * @property rootStyle {object} root element styles
 * @property liStyle {object} li element styles
 */
class Nav extends Component {
  render () {
    return (
      <div className="client-business-info-nav clearfix" style={this.props.rootStyle}>
        <div className="wrapper">
          <ul className="clearfix">
            <li className={this.props.params.type === 'insights' ? 'active' : ''} style={this.props.liStyle}>
              <Link to="/dashboard/data/insights">
                INSIGHTS
              </Link>
            </li>{/*
            <li className={this.props.params.type === 'audience' ? 'active' : ''} style={this.props.liStyle}>
              <Link to="/dashboard/data/audience">
                AUDIENCE
              </Link>
              AUDIENCE
            </li>*/}
          </ul>
        </div>
      </div>
    )
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/InsightsInfo/Nav/Nav.jsx